import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { tierOverrideContext } from 'pages/tierSetUp/tierSetUpResolver';
import { ProvideTableData } from 'shared/providers/provideTableData';
import { TierOverrideApprovals } from './tierOverrideApprovals';

export function TierOverrideApprovalResolver() {

    const defaultTierOverrideApprovalConfig: {initialState?: GridInitialStatePremium} | undefined = {
        initialState: {
            pagination: {
                paginationModel: {
                    page: 0,
                    pageSize: 100,
                },
            }
        },
    }
    
    return (
        <ProvideTableData name='CustomerTierOverride' tableDataContext={tierOverrideContext} config={defaultTierOverrideApprovalConfig}>
            <TierOverrideApprovals />
        </ProvideTableData>
    );
}
